import axios from "axios"
import router from "./router"

const instance = axios.create({
  timeout: 10000000,
  // baseURL: 'http://139.9.202.29:8080'
})
// 在实例已创建后修改默认值
instance.interceptors.request.use(function (config) {

  config.headers.token = localStorage.getItem("token1")

  return config
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error)
})

instance.interceptors.response.use(function (response) {
  if (response.data.code === 401) {
    localStorage.removeItem("token1")
    localStorage.removeItem("role")
    router.push("/login")
  }
  return response
}, function (error) {
  router.push("/404")
  return Promise.reject(error)
})
export default instance



// WEBPACK FOOTER //
// ./src/axios.config.js